import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLicenseStatus } from '../hooks/useLicense'
import { AlertTriangle, Info, X } from 'lucide-react'

export function LicenseExpiryBanner() {
  const { t } = useTranslation()
  const { data: license } = useLicenseStatus()
  const [dismissed, setDismissed] = useState(false)

  if (!license?.warning || dismissed) return null
  if (license.warning === 'expired') return null

  const configs = {
    critical: {
      bg: 'bg-red-50 dark:bg-red-500/10',
      border: 'border-red-200 dark:border-red-500/20',
      text: 'text-red-700 dark:text-red-300',
      Icon: AlertTriangle,
    },
    warning: {
      bg: 'bg-amber-50 dark:bg-amber-500/10',
      border: 'border-amber-200 dark:border-amber-500/20',
      text: 'text-amber-700 dark:text-amber-300',
      Icon: AlertTriangle,
    },
    notice: {
      bg: 'bg-[var(--brand-surface-soft)]',
      border: 'border-[var(--brand-line)]',
      text: 'text-[var(--brand-primary-2)]',
      Icon: Info,
    },
  } as const

  const config = configs[license.warning as keyof typeof configs]
  if (!config) return null

  const { Icon } = config
  const days = license.days_until_expiry ?? 0

  return (
    <div className={`flex items-center justify-between px-4 py-2 border-b ${config.bg} ${config.border}`}>
      <div className="flex items-center gap-2">
        <Icon className={`w-4 h-4 flex-shrink-0 ${config.text}`} />
        <p className={`text-sm ${config.text}`}>
          {license.is_demo
            ? t('license.demoBannerExpiry', { days, defaultValue: `الترخيص التجريبي ينتهي خلال ${days} يوم` })
            : t('license.bannerExpiry', { days, defaultValue: `ترخيصك ينتهي خلال ${days} يوم` })
          }
        </p>
      </div>
      <button onClick={() => setDismissed(true)} className={`${config.text} opacity-60 hover:opacity-100`}>
        <X className="w-4 h-4" />
      </button>
    </div>
  )
}
